export const filterQuestions = (
  questions: PvWizardQuestion[],
  answers?: PvWizardResultsQueryVariables
) => {
  const filteredQuestions = answers
    ? questions.filter(
        question =>
          !question.requiresAnswers ||
          question.requiresAnswers.every(requiredAnswer => {
            const answer = answers[requiredAnswer.key];
            return (
              answer &&
              question.__typename !== 'PvWizardMultiQuestionType' &&
              requiredAnswer.value.includes(answer as string)
            );
          })
      )
    : questions;

  return filteredQuestions;
};
